/**
 * Открыть звонок из вкладки «Головне» так, чтобы это работало и в Bitrix24.
 * Голый `navigate` внутри встроенного приложения уводит сам iframe; образец —
 * `components/alerts/AlertDetailModal.tsx`.
 */
import { useCallback } from 'react';
import { useAppNavigate } from '@/hooks/useAppNavigate';

/**
 * История навигации, по которой запись узнаёт, какую цитату клиента подсветить
 * в стенограмме (#846). Не в адресе: цитата — слова клиента, а адрес уходит в
 * историю браузера, в логи и в пересланные ссылки.
 */
export interface OpenRecordQuoteState {
  objectionQuote?: { recordId: string; quote: string };
}

/**
 * Цитата для подсветки в записи `recordId` — из состояния истории, которое
 * оставил `useOpenRecord`. Только для этой записи: состояние живёт на записи
 * истории, пока панель переключается между разговорами.
 */
export function objectionQuoteFor(state: unknown, recordId: string): string | undefined {
  if (!state || typeof state !== 'object') return undefined;
  const quote = (state as OpenRecordQuoteState).objectionQuote;
  return quote?.recordId === recordId && typeof quote.quote === 'string'
    ? quote.quote
    : undefined;
}

export function useOpenRecord(): (
  recordId: string,
  options?: { quote?: string }
) => void {
  const { appNavigate } = useAppNavigate();
  return useCallback(
    (recordId: string, options?: { quote?: string }) => {
      const state: OpenRecordQuoteState | undefined = options?.quote
        ? { objectionQuote: { recordId, quote: options.quote } }
        : undefined;
      appNavigate(`/records?id=${encodeURIComponent(recordId)}`, {
        embeddedTo: {
          to: '/embedded/dashboard/',
          search: { tab: 'records', recordId },
        },
        ...(state ? { state: { ...state } } : {}),
      });
    },
    [appNavigate]
  );
}
